import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  Grid,
  Badge,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import DashboardHeader from "@components/Header/DashboardHeader";
import GenericBreadCrums from "@components/Breadcrumbs";
import { SiteRoadwaysSection } from "../components/SiteRoadwaysSection";
import { ApplicationStatus } from "../components/ApplicationStatus";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";

import { QrCodeScanner } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@store/store";
import { UploadedDocuments } from "../components/UploadedDocuments";
import { fetchApplicationROWDetails } from "./redux/services/thunk/DetailsThunk";
import { Consent } from "../components/Consent";
import { AmenityLocationSectionROW } from "../components/AmenityLocationSectionROW";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
// @ts-ignore
import html2pdf from "html2pdf.js";
import SeekClarificationModel from "@components/slider/SeekClarificationModel";
import RequestFinalLicence from "../commonModal/RequestFinalLicenceModal";
import RequestExtension from "../commonModal/RequestExtensionModal";
import ConfirmationFinalModal from "../commonModal/ConfirmationFinalModal";
import NoConfirmationFinal from "../commonModal/NoConfirmationFinal";
import ProvisionalLicense from "../commonModal/ProvisionalLicenseModal";
import FinalLicenseModal from "../commonModal/FinalLicenseModal";
import { MediaUpload } from "../components/MediaUpload";
import { fetchReceiptDetailsThunk } from "./redux/services/thunk/DetailsThunk";
import { useNavigate } from "react-router-dom";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { IndividualDetailsROW } from "../components/IndividualDetailsROW";
import { ApplicantOrganisationDetailsROW } from "../components/ApplicantOrganisationDetailsROW";
import RejectRemaks from "./RejectRemaks";
import { app } from "@config/firebaseConfig";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import QRLicenseGeneratorModal from "@modules/application-section/components/QRLicenseGeneratorModal";
import {
  BankGuarantee,
  BankGuaranteeDetails,
} from "../../application-section/components/BankGuarantee";
import {
  fetchApplicationDetailsRow,
  fetchbankguaranteedetailsThunk,
  getTransactionStatusThunk,
} from "@modules/provisional-payment/redux/thunk/application-detailThunk";
import { openFileBySignedUrl } from "../../../utils/getViewSignedUrlHandler";
import {
  getFileSignedURLMorthThunk,
  getFileSignedURLThunk,
} from "@modules/stepper-row/redux/thunk/documentThunk";
import { RenewalDetailsSection } from "@modules/application-section/components/RenewalDetailsSection";
import WithdrawApplicationModel from "@components/slider/WithdrawDrawer";
import WithdrawRemarks from "@modules/application-section-row/application-details-row/WithdrawRemarks";
import SeekClarificationTray from "@components/slider/SeekClarificationTray";
import { RequestReviewDrawer } from "@components/slider/RequestReviewDrawer";
import { getObjectKey } from "@components/buttonGroupView/utils";

const renderStatusBadge = (status: string) => {
  const statusStyles: Record<string, { text: string; bg: string }> = {
    "Inspection Pending": { text: "#9F7803", bg: "#FFF3CD" },
    "Visit Scheduled": { text: "#0471A2", bg: "#D4F0FD" },
    "Report Submitted": { text: "#4CAF50", bg: "#DBEFDC" },
    "Recommended to CA": { text: "#2196F3", bg: "#D3EAFD" },
    "Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
    "Final Application Rejected": { text: "#B3261D", bg: "#F0D4D2" },
    "Renewal Rejected": { text: "#B3261D", bg: "#F0D4D2" },
    "Payment Pending": { text: "#B86D00", bg: "#FFEACC" },
    "Payment Received": { text: "#43A047", bg: "#D9ECDA" },
    "Forwarded to Competent Authority": { text: "#1976D2", bg: "#D1E4F6" },
    "Provisional NOC Issued": { text: "#6FA135", bg: "#E2ECD7" },
    "EOT Requested": { text: "#AB47BC", bg: "#EEDAF2" },
    "EOT Approved": { text: "#6A1B9A", bg: "#E1D1EB" },
    "EOT Rejected": { text: "#E53935", bg: "#FAD7D7" },
    "Clarification Requested": { text: "#FF7043", bg: "#FFE2D9" },
    "Clarification Updated": { text: "#26A69A", bg: "#D4EDEB" },
    "Final NOC Issued": { text: "#2E7D32", bg: "#D5E5D6" },
    "Application Submitted": { text: "#154321", bg: "#AEDCBA" },
    Draft: { text: "#757575", bg: "#ECECEC" },
    "Scrutiny Pending": { text: "#9F7803", bg: "#FFF3CD" },
    "BG Forfeiture Initiated": { text: "#B3261D", bg: "#F0D4D2" },
  };

  const defaultStyle = { text: "#374151", bg: "#f3f4f6" };
  const style = statusStyles[status] || defaultStyle;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 1.5,
        py: 0.5,

        bgcolor: style.bg,
        color: style.text,
        // Added styles as per request
        padding: "4px 10px",
        borderRadius: "6px",
        fontSize: "12px",
        fontWeight: 600,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: 4,
          height: 4,
          borderRadius: "50%",
          bgcolor: style.text,
        }}
      ></Box>
      {status}
    </Box>
  );
};

export const ApplicationDetailsROW: React.FC = () => {
  const navigate = useNavigate();
  const [isRequestExtensionOpen, setIsRequestExtensionOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(true);
  const [isPaymentOpen, setIsPaymentOpen] = React.useState(false);
  const [isFinalPaymentOpen, setIsFinalPaymentOpen] = React.useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // NEW
  const [consentCheck, setConsentCheck] = useState(false);
  const [openseek, setOpenseek] = useState(false);
  const printRef = useRef<HTMLDivElement | null>(null);
  const [receiptDetails, setReceiptDetails] = React.useState<any>(null);
  const [isReviewDrawerOpen, setIsReviewDrawerOpen] = useState(false);

  const [isUploadMediaOpen, setIsUploadMediaOpen] = React.useState(false);
  const [isConfirmationFLOpen, setIsConfirmationFLOpen] = useState(false);
  const [isNoConfirmationFLOpen, setIsNoConfirmationFLOpen] = useState(false);
  const [openProvisionalQR, setOpenProvisionalQR] = useState(false);
  const [openFinalQR, setOpenFinalQR] = useState(false);
  const [openQR, setOpenQR] = useState(false);
  const [isGenerating, setIsGenerating] = useState<boolean>(false);
  const [openWithdrawDrawer, setOpenWithdrawDrawer] = React.useState(false);

  // preview
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [timers, setTimers] = useState<any>({});
  const [openClarificationTray, setOpenClarificationTray] = useState(false);
  const [isApplicationDetailsExpanded, setIsApplicationDetailsExpanded] =
    useState({
      individualDetails: true,
      organisationDetails: false,
      ammentiesDetails: false,
      siteRoadways: false,
      documents: false,
      uploadMedia: false,
      consent: false,
      bankGuarateeDetails: false,
      renewalDetails: false,
    });
  const [bankGuaranteeDetails, setBankGuaranteeDetails] =
    useState<BankGuarantee>();
  const dispatch = useDispatch<AppDispatch>();

  const { applicationDetailsROW, loading, error } = useSelector(
    (state: RootState) => state.applicationDetailsROW,
  );

  const applicantName = applicationDetailsROW?.created_by_uname || "";
  const amenityName = applicationDetailsROW?.property_type || "";
  const area = applicationDetailsROW?.location_type_name || "";
  const locationAddress = applicationDetailsROW?.address_1 || "";

  const { access_id } = useSelector(
    (state: RootState) => state.amenitiesROW || {},
  );

  const applicationEditId = useSelector(
    (state: RootState) => state.applicationDashboard?.id || 0,
  );

  const applicationId = access_id || applicationEditId;

  const fetchBankGuaranteeDetails = async () => {
    const res = await dispatch(fetchbankguaranteedetailsThunk(applicationId));
    setBankGuaranteeDetails(res?.payload);
  };

  const fetchTransactionStatus = async (
    application_id: any,
    category: string,
  ) => {
    try {
      const res = await dispatch(
        getTransactionStatusThunk(application_id),
      ).unwrap();
      if (res?.status) {
        navigate(
          "/esign?" +
            (category == "row"
              ? `row=${application_id}`
              : `access=${application_id}`),
        );
      } else {
        navigate(
          "/payment?" +
            (category == "row"
              ? `row=${application_id}`
              : `access=${application_id}`),
        );
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
    }
  };

  useEffect(() => {
    dispatch(fetchApplicationROWDetails(access_id || applicationEditId));
    fetchBankGuaranteeDetails();
  }, [dispatch]);

  useEffect(() => {
    if (applicationId) {
      dispatch(fetchReceiptDetailsThunk(applicationId)).then((res: any) => {
        if (res.payload?.success && Array.isArray(res.payload.data)) {
          setReceiptDetails(res.payload.data);
        }
      });
    }
  }, [applicationId]);

  React.useEffect(() => {
    if (!showAlert) return;

    const timer = setTimeout(() => {
      setShowAlert(false);
    }, 8000); // 8 seconds

    return () => clearTimeout(timer);
  }, [showAlert]);

  const {
    application_code,
    application_status,
    status_id,
    next_steps,
    created_at,
    provisional_licence_url,
    final_licence_url,
    provisional_license_date,
    final_license_date,
    tat_info,
    renewal_license_url,
    renewal_license_date,
    provisional_expiry_date,
    final_expiry_date,
    renewal_expiry_date,
    is_legacy,
    current_phase,
    bg_reupload_req,
    ca_provisional_remarks,
    ca_final_remarks,
    ca_renewal_remarks,
  } = applicationDetailsROW || {};

  // Days the remarks UI stays visible after the remark was created
  const VISIBILITY_DAYS = 30;

  // Map each phase directly to its remarks object
  const PHASE_REMARKS_MAP = {
    PROVISIONAL: ca_provisional_remarks,
    FINAL: ca_final_remarks,
    RENEWAL: ca_renewal_remarks,
  } as const;

  // Resolve the remarks object based on the current phase
  const phaseRemarks =
    PHASE_REMARKS_MAP[current_phase as keyof typeof PHASE_REMARKS_MAP] ?? null;

  // Date window check
  const createdAt = phaseRemarks?.created_at;

  const isWithinWindow = (() => {
    if (!createdAt) return false;

    const created = new Date(createdAt).getTime(); // number
    if (isNaN(created)) return false;

    const now = Date.now(); // number
    const diffInMs = now - created;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays >= 0 && diffInDays <= VISIBILITY_DAYS;
  })();

  // Show only when:
  // 1. current_phase is one of PROVISIONAL / FINAL / RENEWAL
  // 2. that phase's remarks object exists (not null)
  // 3. created_at is within the last 30 days
  const showRejectionRemarks = !!phaseRemarks && !!createdAt && isWithinWindow;

  // Expiry = created_at + VISIBILITY_DAYS
  const expiryDate = createdAt
    ? new Date(new Date(createdAt).getTime() + VISIBILITY_DAYS * 86400000)
    : null;

  // Days remaining (rounded down, min 0)
  const daysLeft = createdAt
    ? Math.max(0, Math.floor((expiryDate!.getTime() - Date.now()) / 86400000))
    : 0;

  // Formatted date, e.g. "August 23, 2026"
  const expiryDateLabel = expiryDate?.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const handleOpenReviewDrawer = () => {
    setIsReviewDrawerOpen(true);
  };

  const handleCloseReviewDrawer = () => {
    setIsReviewDrawerOpen(false);
  };

  useEffect(() => {
    if (
      !provisional_expiry_date &&
      !final_expiry_date &&
      !renewal_expiry_date
    ) {
      return;
    }

    const interval = setInterval(() => {
      setTimers({
        provisional: getTimeLeft(provisional_expiry_date),
        final: getTimeLeft(final_expiry_date),
        renewal: getTimeLeft(renewal_expiry_date),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [provisional_expiry_date, final_expiry_date, renewal_expiry_date]);

  if (!applicationDetailsROW) return;

  const rejectRemaks = (() => {
    switch (status_id) {
      case 5: // provisional reject
        return applicationDetailsROW?.ca_provisional_remarks?.comments || "";
      case 27: // final reject
        return applicationDetailsROW?.ca_final_remarks?.comments || "";
      case 48: // payment reject
        return applicationDetailsROW?.bg_remarks || "";
      default:
        return "";
    }
  })();

  const rejectRemaksDocument = (() => {
    switch (status_id) {
      case 5: // provisional reject
        return (
          (applicationDetailsROW as any)?.ca_provisional_remarks
            ?.remark_document || ""
        );
      case 27: // final reject
        return (
          (applicationDetailsROW as any)?.ca_final_remarks?.remark_document ||
          ""
        );
      case 73: // renewal reject
        return (
          (applicationDetailsROW as any)?.ca_renewal_remarks?.remark_document ||
          ""
        );
      default:
        return "";
    }
  })();

  const withdrawalRemarks = (() => {
    return (applicationDetailsROW as any)?.withdrawal_details?.remarks || "";
  })();

  const toggleApplicationPreviewSections = (expanded: boolean) => {
    setIsApplicationDetailsExpanded({
      individualDetails: expanded,
      organisationDetails: expanded,
      ammentiesDetails: expanded,
      siteRoadways: expanded,
      documents: expanded,
      uploadMedia: expanded,
      consent: expanded,
      bankGuarateeDetails: expanded,
      renewalDetails: expanded,
    });
  };

  const allCollapsed = Object.values(isApplicationDetailsExpanded).every(
    (value) => value === false,
  );

  const breadcrumbData = [{ label: "Application Details", link: "#" }];

  const open = Boolean(anchorEl);

  const handleClickActions = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formattedDate = new Date(created_at).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  const formattedDueDate = tat_info?.deadline
    ? new Date(tat_info?.deadline || "").toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  const waitForImagesToLoad = async (element: HTMLElement): Promise<void> => {
    const images = Array.from(
      element.querySelectorAll<HTMLImageElement>("img"),
    );

    const promises = images.map((img) => {
      if (img.complete) return Promise.resolve();

      return new Promise<void>((resolve) => {
        img.onload = () => resolve();
        img.onerror = () => resolve();
      });
    });

    await Promise.all(promises);
  };

  const waitForCondition = async (
    condition: () => boolean,
    interval = 100,
  ): Promise<void> => {
    return new Promise((resolve) => {
      const check = () => {
        if (condition()) {
          resolve();
        } else {
          setTimeout(check, interval);
        }
      };
      check();
    });
  };

  const handleDownloadPDF = async (): Promise<void> => {
    if (!printRef.current || isGenerating) return;

    try {
      setIsGenerating(true);

      // 1️⃣ Expand sections
      toggleApplicationPreviewSections(true);

      // 2️⃣ Wait until API loading is finished
      await waitForCondition(() => !loading);

      // 3️⃣ Small delay to let React fully paint UI
      await new Promise((resolve) => setTimeout(resolve, 500));

      // 4️⃣ Wait for images
      await waitForImagesToLoad(printRef.current);

      // 5️⃣ Extra delay for layout stability (very important for MUI)
      await new Promise((resolve) => setTimeout(resolve, 400));

      // 6️⃣ Generate PDF
      await html2pdf()
        .set({
          margin: 0.4,
          filename: `Application_Details_${application_code || "download"}.pdf`,
          html2canvas: {
            scale: 2,
            useCORS: true,
          },
          jsPDF: { unit: "in", format: "a3", orientation: "portrait" },
        })
        .from(printRef.current)
        .save();
    } catch (error) {
      console.error("PDF generation failed:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleOpenseek = () => {
    setOpenseek(true);
  };
  const handleCloseseek = () => {
    setOpenseek(false);
  };

  const handleViewFile = (doc_name: any) => {
    openFileBySignedUrl({
      document_name: doc_name,
      dispatch,
      getSignedUrlThunk: getFileSignedURLMorthThunk,
    });
  };

  const handleViewRemarkDocument = (document: any) => {
    if (!document?.upload_path) {
      return;
    }

    openFileBySignedUrl({
      document_name: getObjectKey(document.upload_path),
      dispatch,
      getSignedUrlThunk: document.upload_path.includes("noc")
        ? getFileSignedURLThunk
        : getFileSignedURLMorthThunk,
    });
  };

  const getTimeLeft = (expiryDate?: string) => {
    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate).getTime();

    if (isNaN(expiry)) return null;

    const diff = expiry - now;
    if (diff <= 0) return null;

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };

  const renderTimer = (time: any) => {
    if (!time) return null; // 👉 don't render strip

    if (
      time.days === 0 &&
      time.hours === 0 &&
      time.minutes === 0 &&
      time.seconds === 0
    ) {
      return "Your license has expired";
    }

    if (time.days === 0) {
      return `${time.hours} Hours ${time.minutes} Minutes ${time.seconds} Seconds`;
    }

    return `${time.days} Days ${time.hours} Hours ${time.minutes} Minutes ${time.seconds} Seconds`;
  };

  const renderTimeStrip = (label: string, time: any) => {
    const timerText = renderTimer(time);

    if (!timerText) return null;

    const isExpired = timerText === "Your license has expired";

    return (
      <Typography
        className={`body-xs gray-900 py-3 text-center ${
          isExpired ? "bg-red-100" : "bg-orange-100"
        }`}
      >
        {isExpired ? (
          <strong>{timerText}</strong>
        ) : (
          <>
            {label} Ends in <strong>{timerText}</strong>
          </>
        )}
      </Typography>
    );
  };

  return (
    <Box className="app-details-wrapper login-root">
      <div className="page-content">
        {/* <DashboardHeader /> */}
        <GenericBreadCrums breadcrumbs={breadcrumbData} className="mt-6" />
        <SeekClarificationModel
          open={openseek}
          onClose={handleCloseseek}
          access_id={access_id}
          onSuccess={() => dispatch(fetchApplicationROWDetails(access_id))}
          isROW={true}
        />
        <SeekClarificationTray
          open={openClarificationTray}
          onClose={() => setOpenClarificationTray(false)}
          accessId={access_id}
          row={true}
          fetchRow={() => dispatch(fetchApplicationROWDetails(applicationId))}
        />
        <Box className="app-details-card" ref={printRef}>
          <Box className="application-banner">
            <Box
              className="application-banner-header"
              sx={{ gap: { xs: 2, sm: 0 } }}
            >
              <Typography className="application-id flex gap-4 items-center ">
                {application_code}
                {/* <span className="status-badge">{application_status}</span> */}

                {application_status &&
                  renderStatusBadge(
                    applicationDetailsROW?.clk_req_applicant
                      ? "Clarification Requested"
                      : application_status,
                  )}
              </Typography>
              <Box className="banner-buttons gap-3 flex flex-wrap">
                {/* {status_id === 42 && (
                  <Button
                    variant="outlined"
                    className="btn-outline-purple"
                    onClick={handleOpenseek}
                    sx={{
                      borderRadius: "16px",
                      border: "1px solid #3a1c73 !important",
                      fontSize: "2rem",
                      color: "#3A1C73",
                      fontWeight: 500,
                      px: 2,
                      py: 0.5,
                      background: "#fff",
                      boxShadow: "none",
                      textTransform: "none",
                    }}
                  >
                    Clarification
                  </Button>
                )} */}

                {status_id === 43 && (
                  <Badge
                    badgeContent={1}
                    color="error"
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn-outline-purple"
                      onClick={handleOpenseek}
                      sx={{
                        fontFamily: "Inter",
                        border: "1px solid #3a1c73 !important",
                        fontSize: "14px",
                        color: "#3A1C73",
                        fontWeight: 500,
                        px: 2,
                        py: 0.5,
                        background: "#fff",
                        boxShadow: "none",
                        textTransform: "none",
                        height: "40px",
                        right: "6%",
                      }}
                    >
                      Clarification
                    </Button>
                  </Badge>
                )}

                {status_id === 6 && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    startIcon={<CreditCardOutlinedIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      // navigate("/payment?row=" + applicationId);
                      fetchTransactionStatus(applicationId, "row");
                    }}
                  >
                    Pay Provisional NOC Fee
                  </Button>
                )}
                {(status_id === 48 ||
                  applicationDetailsROW?.bg_reupload_req) && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    sx={{ borderRadius: "2rem !important" }}
                    startIcon={<DescriptionOutlinedIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/bg-reupload?row=" + applicationId);
                    }}
                  >
                    Submit electronic Bank Guarantee (e-BG)
                  </Button>
                )}
                {/* {(status_id === 8 || status_id === 9 || status_id === 10) && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    onClick={handleClickActions}
                    endIcon={
                      <Box>
                        {open ? (
                          <ExpandLessIcon className="dropdown-icon" />
                        ) : (
                          <ExpandMoreIcon className="dropdown-icon" />
                        )}
                      </Box>
                    }
                  >
                    Action
                  </Button>
                )} */}
                {/* <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      borderRadius: "8px"
                    }
                  }}
                >
                  {provisional_licence_url && (
                    <MenuItem
                      onClick={() => {
                        const url =
                          process.env.REACT_APP_API_IMAGE_URL +
                          "morth-documents/access/" +
                          provisional_licence_url;
                        window.open(url, "_blank");
                      }}
                    >
                      View Provisional NOC
                    </MenuItem>
                  )}
                  {final_licence_url && (
                    <MenuItem
                      onClick={() => {
                        const url =
                          process.env.REACT_APP_API_IMAGE_URL +
                          "morth-documents/access/" +
                          final_licence_url;
                        window.open(url, "_blank");
                      }}
                    >
                      View Final NOC
                    </MenuItem>
                  )}
                </Menu> */}
                {/* <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{
                    style: {
                      borderRadius: "8px",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      // setIsConfirmationFLOpen(true);
                      setIsUploadMediaOpen(true);
                      handleClose();
                    }}
                  >
                    Apply for Final NOC
                  </MenuItem>
                </Menu> */}
                {/* )} */}
                {/* Final NOC Payment Button */}
                {status_id === 35 && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    startIcon={<CreditCardOutlinedIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/final-license-fee");
                    }}
                  >
                    Pay Final NOC Fee
                  </Button>
                )}

                {[8, 9, 10].includes(status_id) && (
                  <>
                    <Button
                      variant="contained"
                      className="btn-filled-purple"
                      sx={{ borderRadius: "50px !important", ml: 1 }}
                      onClick={() => {
                        setIsUploadMediaOpen(true);
                        handleClose();
                      }}
                    >
                      Apply For Final NOC
                    </Button>
                  </>
                )}

                {(status_id === 14 || status_id === 79) && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    startIcon={<CreditCardOutlinedIcon />}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(
                        `/apply-renewal?row=${applicationDetailsROW?.application_id}&category=${applicationDetailsROW?.utility_type}`,
                      );
                    }}
                  >
                    Apply for Renewal
                  </Button>
                )}

                {status_id === 76 && (
                  <Button
                    variant="contained"
                    className="btn-filled-purple"
                    startIcon={<DriveFileRenameOutlineOutlinedIcon />}
                    onClick={() => {
                      navigate("/esign?row=" + applicationId);
                    }}
                  >
                    Proceed to E-sign
                  </Button>
                )}

                {((current_phase &&
                  current_phase == "PROVISIONAL" &&
                  status_id != 7 &&
                  status_id != 8 &&
                  status_id != 81) ||
                  status_id == 85) && (
                  <Button
                    variant="contained"
                    className="btn-outline-purple"
                    startIcon={<AssignmentReturnIcon />}
                    sx={{
                      border: "1px solid #3a1c73 !important",
                      borderRadius: "50px !important",
                      color: "#3a1c73",
                      ml: 1,
                      boxShadow: "none",
                      bgcolor: "#fff",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenWithdrawDrawer(true);
                    }}
                  >
                    Withdraw Application
                  </Button>
                )}

                {applicationDetailsROW?.clk_req_applicant && (
                  <Badge
                    badgeContent="1"
                    color="error"
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    sx={{
                      "& .MuiBadge-badge": {
                        minWidth: 20,
                        height: 20,
                        borderRadius: "50%",
                        fontWeight: 600,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #fff",
                        top: 6,
                        right: 6,
                      },
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => setOpenClarificationTray(true)}
                      sx={{
                        border: "1.5px solid #3A1C73",
                        borderRadius: "24px",
                        // minWidth: "160px",
                        // height: "40px",
                        color: "#3A1C73",
                        textTransform: "none",
                        backgroundColor: "#fff",
                        fontSize: 14,

                        "&:hover": {
                          border: "1.5px solid #3A1C73",
                          backgroundColor: "#F8F5FF",
                        },
                      }}
                    >
                      Seek Clarification
                    </Button>
                  </Badge>
                )}

                <Button
                  variant="outlined"
                  className="btn-outline-purple"
                  onClick={handleDownloadPDF}
                  sx={{
                    border: "1px solid #3a1c73 !important",
                    padding: "10px 2px",
                    borderRadius: "50px !important",
                    width: "40px !important",
                    color: "#3a1c73",
                    ml: 1,
                    visibility: isGenerating ? "hidden" : "visible",
                  }}
                >
                  <FileDownloadIcon />
                </Button>

                {isGenerating && <CircularProgress size={30} />}
              </Box>
            </Box>
            <Box
              className="application-subinfo"
              sx={{
                flexWrap: "wrap",
                gap: { xs: 1, md: 2 },
                mt: { xs: 2, md: 0 },
              }}
            >
              <Typography className="app-date">
                Application Date: <strong>{formattedDate}</strong>
              </Typography>
              {next_steps && (
                <Typography className="app-next-step">
                  Next Steps:{" "}
                  <strong>
                    {application_status == "Provisional NOC Issued"
                      ? "Apply for Final NOC"
                      : next_steps}
                  </strong>
                </Typography>
              )}
              {status_id != 8 && tat_info && (
                <Typography className="app-payment-due">
                  {tat_info?.tat_description}:{" "}
                  <strong>
                    {formattedDueDate}{" "}
                    {tat_info?.remaining_days &&
                      `(${tat_info.remaining_days} days left)`}
                  </strong>
                </Typography>
              )}
            </Box>
            {/* Demand Note Alert */}
            {/* Demand Note Alert */}
            {showAlert &&
              status_id != null &&
              [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 18, 25, 27, 28,
                31, 33, 35, 37, 40, 42, 43, 44, 48, 49, 51, 52, 57, 62, 63, 68,
                69, 72, 73, 74, 75, 76, 77, 78, 79, 81, 85,
              ].includes(status_id) && (
                <Box
                  className="application-alert"
                  sx={{
                    background: [5, 11, 27, 48, 62, 81].includes(status_id)
                      ? "linear-gradient(90deg, #B3261D 0%, #B3261D 100%)"
                      : "linear-gradient(90deg, #60bc6b 0%, #60bc6b 100%)",
                  }}
                >
                  <Box className="alert-icon">
                    <CircleNotificationsIcon
                      fontSize="medium"
                      className="alert-notification-icon"
                    />
                  </Box>
                  {status_id === 1 && (
                    <Typography className="alert-text">
                      Your Application ID: {application_code} is currently in
                      Draft mode. Please complete and submit to proceed further.
                    </Typography>
                  )}
                  {status_id === 2 && (
                    <Typography className="alert-text">
                      {is_legacy
                        ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                        : `Congratulations! Your Application ID: ${application_code} has been submitted successfully.`}
                    </Typography>
                  )}
                  {status_id === 3 && (
                    <Typography className="alert-text">
                      Good news! A site visit has been scheduled for your
                      Application ID: {application_code}. Please be available on
                      the assigned date.
                    </Typography>
                  )}
                  {status_id === 4 && (
                    <Typography className="alert-text">
                      Your Application ID: {application_code} is under scrutiny
                      by the authority. Kindly wait for further updates.
                    </Typography>
                  )}
                  {status_id === 5 && (
                    <Typography className="alert-text">
                      We regret to inform you that your Application ID:{" "}
                      {application_code} has been rejected. Please check remarks
                      and reapply if eligible.
                    </Typography>
                  )}
                  {status_id === 27 && (
                    <Typography className="alert-text">
                      We regret to inform you that your Application ID:{" "}
                      {application_code} has been rejected. Please check remarks
                      and reapply if eligible.
                    </Typography>
                  )}
                  {status_id === 6 && (
                    <Typography className="alert-text">
                      Action Required! Your Application ID: {application_code}{" "}
                      has received in-principle approval. Please complete the
                      payment to proceed further.
                    </Typography>
                  )}

                  {status_id === 7 &&
                    new Date() <
                      new Date(
                        applicationDetailsROW?.public_comment_period_end,
                      ) && (
                      <Typography className="alert-text">
                        Congratulation! Payment has been received. Your
                        application has been published on the Ministry of Road
                        Transport & Highways (MoRTH) website for inviting public
                        comments for a period of 30 days.
                        <a
                          target="_blank"
                          href="https://morth.nic.in/en/fuel_stations_retail_outlet"
                          rel="noreferrer"
                        >
                          {" "}
                          [Click here to view]
                        </a>
                      </Typography>
                    )}
                  {status_id === 7 &&
                    new Date() >=
                      new Date(
                        applicationDetailsROW?.public_comment_period_end,
                      ) && (
                      <Typography className="alert-text">
                        Thank you! Your payment has been received successfully
                        for your Application ID: {application_code}.
                      </Typography>
                    )}
                  {status_id === 8 && (
                    <Typography className="alert-text">
                      {is_legacy
                        ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                        : `Congratulations! A Provisional NOC has been issued for Application ID: ${application_code}. Download your license from the portal.`}
                    </Typography>
                  )}
                  {status_id === 9 && (
                    <Typography className="alert-text">
                      Your request for Extension of Provisional NOC has been
                      submitted for Application ID: {application_code}.
                    </Typography>
                  )}
                  {status_id === 10 && (
                    <Typography className="alert-text">
                      Congratulations! Your Provisional NOC Extension request
                      for Application ID: {application_code} has been approved.
                    </Typography>
                  )}
                  {status_id === 11 && (
                    <Typography className="alert-text">
                      We regret to inform you that your Provisional NOC
                      Extension request for Application ID: {application_code}{" "}
                      has been rejected. Please review remarks and take further
                      action.
                    </Typography>
                  )}
                  {status_id === 12 && (
                    <Typography className="alert-text">
                      Clarification Your Application has been requested by the
                      Competent Authority for Application ID: {application_code}
                      . Please provide the required details at the earliest.
                    </Typography>
                  )}
                  {status_id === 40 && (
                    <Typography className="alert-text">
                      Clarification Your Application has been requested by the
                      Competent Authority for Application ID: {application_code}
                      . Please provide the required details at the earliest.
                    </Typography>
                  )}
                  {status_id === 43 && (
                    <Typography className="alert-text">
                      Clarification Your Application has been requested by the
                      Competent Authority for Application ID: {application_code}
                      . Please provide the required details at the earliest.
                    </Typography>
                  )}
                  {status_id === 42 && (
                    <Typography className="alert-text">
                      Clarification Your Application has been submitted
                      successfully for Application ID: {application_code}.
                      Awaiting further review by the Competent Authority.
                    </Typography>
                  )}
                  {status_id === 14 && (
                    <Typography className="alert-text">
                      {is_legacy
                        ? `This application has been onboarded on the Rajmarg Pravesh Portal.`
                        : `Congratulations! Final NOC has been issued for Application ID: ${application_code}. Download your license from the
                      portal.`}
                    </Typography>
                  )}
                  {status_id === 15 && (
                    <Typography className="alert-text">
                      Your renewal application for Application ID:{" "}
                      {application_code} has been submitted successfully.
                    </Typography>
                  )}

                  {status_id === 18 && (
                    <Typography className="alert-text">
                      Congratulations! Your Application ID:
                      {application_code} has been submitted successfully.
                    </Typography>
                  )}
                  {status_id === 25 && (
                    <Typography className="alert-text">
                      Congratulations! Your Application ID:
                      {application_code} has been submitted successfully.
                    </Typography>
                  )}
                  {status_id === 28 && (
                    <Typography className="alert-text">
                      Thank you! Payment has been received successfully for your
                      Application ID: {application_code}.
                    </Typography>
                  )}
                  {status_id === 33 && (
                    <Typography className="alert-text">
                      Thank you! Payment has been received successfully for your
                      Application ID: {application_code}.
                    </Typography>
                  )}
                  {status_id === 31 && (
                    <Typography className="alert-text">
                      Good news! A site visit has been scheduled for your
                      Application ID: {application_code}. Please be available on
                      the assigned date.
                    </Typography>
                  )}
                  {status_id === 35 && (
                    <Typography className="alert-text">
                      Action Required! Your application with application ID:{" "}
                      {application_code} has been approved by the authority.
                      Please complete the payment to proceed further.
                    </Typography>
                  )}
                  {status_id === 37 && (
                    <Typography className="alert-text">
                      Action Required! Your Application ID:
                      {application_code} has received final approval. Please
                      complete the payment to proceed further.
                    </Typography>
                  )}
                  {status_id === 49 && (
                    <Typography className="alert-text">
                      Pending for public comments.
                    </Typography>
                  )}
                  {status_id === 44 && (
                    <Typography className="alert-text">
                      Your application is currently pending for publication on
                      the Ministry of Road Transport & Highways (MoRTH) website.
                      Once published, it will be open for inviting public
                      comments for a period of 30 days.
                    </Typography>
                  )}
                  {status_id === 51 && (
                    <Typography className="alert-text">
                      EOT Under Review: Your Extension request for Application
                      ID: {application_code} is under review with AS/JS.
                    </Typography>
                  )}
                  {status_id === 52 && (
                    <Typography className="alert-text">
                      EOT Under Review: Your Extension request for Application
                      ID: {application_code} is under review with the Secretary.
                    </Typography>
                  )}
                  {status_id === 62 && (
                    <Typography className="alert-text">
                      Bank Guarantee forfeiture process has been initiated for
                      Application ID: {application_code} as per applicable
                      provisions.
                    </Typography>
                  )}
                  {status_id === 63 && (
                    <Typography className="alert-text">
                      Good news! A site visit has been scheduled for your
                      Application ID: {application_code} for renewal. Please be
                      available on the assigned date.
                    </Typography>
                  )}
                  {status_id === 69 && (
                    <Typography className="alert-text">
                      Your renewal application for Application ID:{" "}
                      {application_code} is under scrutiny by the concerned
                      authority. Further updates will be communicated in due
                      course.
                    </Typography>
                  )}
                  {status_id === 72 && (
                    <Typography className="alert-text">
                      Your renewal application for Application ID:{" "}
                      {application_code} has been approved by the Competent
                      Authority.
                    </Typography>
                  )}
                  {status_id === 73 && (
                    <Typography className="alert-text">
                      Your renewal application for Application ID:{" "}
                      {application_code} has been rejected by the Competent
                      Authority. Kindly refer to the remarks on the portal for
                      further action.
                    </Typography>
                  )}
                  {status_id === 74 && (
                    <Typography className="alert-text">
                      The Renewal NOC for Application ID: {application_code} has
                      been issued successfully. Please download the renewed
                      license from the portal.
                    </Typography>
                  )}
                  {status_id === 75 && (
                    <Typography className="alert-text">
                      Your Extension request for Application ID:{" "}
                      {application_code} has been returned and is currently
                      under review with the Nodal Officer.
                    </Typography>
                  )}
                  {status_id === 68 && (
                    <Typography className="alert-text">
                      Your Extension request for Application ID:{" "}
                      {application_code} is under review with Competent
                      Authority.
                    </Typography>
                  )}
                  {status_id === 76 && (
                    <Typography className="alert-text">
                      Your E-sign request for Application ID: {application_code}{" "}
                      has been pending. Please complete the E-sign process to
                      proceed further.
                    </Typography>
                  )}
                  {status_id === 77 && (
                    <Typography className="alert-text">
                      Your Application ID: {application_code} is pending for
                      provisional verification by the concerned authority.
                      Please wait for further updates.
                    </Typography>
                  )}
                  {(status_id === 78 || status_id === 85) && (
                    <Typography className="alert-text">
                      Your Application ID: {application_code} is pending for
                      final verification by the concerned authority. Please wait
                      for further updates.
                    </Typography>
                  )}
                  {status_id === 79 && (
                    <Typography className="alert-text">
                      Your Final NOC for Application ID: {application_code} is
                      expiring soon. Kindly initiate the renewal process at the
                      earliest to avoid any disruption.
                    </Typography>
                  )}

                  {status_id === 57 && (
                    <Typography className="alert-text">
                      EOT Under Review: Your Extension request for Application
                      ID: {application_code} is under review with Nodal Officer.
                    </Typography>
                  )}
                  {status_id === 81 && (
                    <Typography className="alert-text">
                      Application withdrawn successfully! Your application with
                      Application ID: {application_code} has been withdrawn and
                      no further processing will be carried out for this
                      application.
                    </Typography>
                  )}
                  <Box
                    className="alert-close"
                    onClick={() => setShowAlert(false)}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon />
                  </Box>
                </Box>
              )}
            <br />
            <Divider className="app-divider" />
            <br />
            {renewal_license_url && status_id === 74 && (
              <>
                <Box className="license-info-bar rounded-3xl mt-3 overflow-hidden">
                  {renderTimeStrip("Renewal NOC", timers.renewal)}
                  <Box
                    className="license-info-bar"
                    sx={{
                      background: "#EEFFF5",
                      borderRadius: "12px",
                      display: "flex",
                      gap: 2,
                      flexWrap: "wrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                      py: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          background: "#34A853",
                          borderRadius: "8px",
                          width: 35,
                          height: 35,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DescriptionIcon sx={{ color: "#fff", fontSize: 22 }} />
                      </Box>

                      <Box>
                        <Typography
                          className="body-xxs"
                          sx={{ fontWeight: 600 }}
                        >
                          Renewal NOC
                        </Typography>
                        <Typography className="body-xxs gray-900">
                          {renewal_license_date
                            ? (() => {
                                const expiryDate = new Date(
                                  renewal_expiry_date,
                                );
                                return `Expire on ${expiryDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )}`;
                              })()
                            : ""}
                        </Typography>
                      </Box>
                    </Box>

                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          background: "#3A1C73",
                          borderRadius: "999px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 12,
                          boxShadow: "none",
                          "&:hover": { background: "#2a145c" },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          if (renewal_license_url) {
                            handleViewFile(renewal_license_url);
                          }
                        }}
                      >
                        Download
                      </Button>

                      <IconButton
                        sx={{
                          ml: 2,
                          bgcolor: "#3A1C73",
                          "&:hover": {
                            bgcolor: "#2E155D",
                          },
                        }}
                        onClick={() => setOpenQR(true)}
                      >
                        <QrCodeScanner sx={{ color: "#fff" }} />
                      </IconButton>

                      <QRLicenseGeneratorModal
                        open={openQR}
                        onClose={() => setOpenQR(false)}
                        licenseURL={renewal_license_url}
                        licenseType="renewal"
                        moduleType="access"
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            )}
            {provisional_license_date &&
            provisional_licence_url &&
            status_id === 8 ? (
              <>
                <Box className="license-info-bar rounded-3xl mt-3 overflow-hidden">
                  {renderTimeStrip("Provisional NOC", timers.provisional)}
                  <Box
                    sx={{
                      background: "#EEFFF5",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                      py: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          background: "#34A853",
                          borderRadius: "8px",
                          width: 35,
                          height: 35,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <DescriptionIcon sx={{ color: "#fff", fontSize: 22 }} />
                      </Box>
                      <Box>
                        <Typography
                          className="body-xxs"
                          sx={{ fontWeight: 600 }}
                        >
                          Provisional NOC
                        </Typography>
                        <Typography className="body-xxs gray-900">
                          {provisional_license_date
                            ? (() => {
                                const expiryDate = new Date(
                                  provisional_expiry_date,
                                );
                                return `Expire on ${expiryDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )}`;
                              })()
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          background: "#3A1C73",
                          borderRadius: "999px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 12,
                          boxShadow: "none",
                          "&:hover": { background: "#2a145c" },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          // Replace with your actual download logic
                          if (provisional_licence_url) {
                            handleViewFile(provisional_licence_url);
                          }
                        }}
                      >
                        Download
                      </Button>
                      <IconButton
                        sx={{
                          ml: 2,
                          bgcolor: "#3A1C73",
                          "&:hover": {
                            bgcolor: "#2E155D",
                          },
                        }}
                        onClick={() => {
                          setOpenProvisionalQR(true);
                        }}
                      >
                        <QrCodeScanner sx={{ color: "#fff" }} />
                      </IconButton>

                      <QRLicenseGeneratorModal
                        open={openProvisionalQR}
                        onClose={() => setOpenProvisionalQR(false)}
                        licenseURL={provisional_licence_url}
                        licenseType="provisional"
                        moduleType="row"
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            ) : (
              final_license_date &&
              final_licence_url &&
              status_id === 14 && (
                <Box className={`license-info-bar rounded-3xl overflow-hidden`}>
                  {renderTimeStrip("Final NOC", timers.final)}
                  <Box
                    className="license-info-bar"
                    sx={{
                      background: "#EEFFF5",
                      borderRadius: "12px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 2,
                      alignItems: "center",
                      justifyContent: "space-between",
                      px: 3,
                      py: 1,
                      mt: 2,
                      margin: "auto",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          background: "#34A853",
                          borderRadius: "8px",
                          width: 35,
                          height: 35,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "auto",
                        }}
                      >
                        <DescriptionIcon sx={{ color: "#fff", fontSize: 22 }} />
                      </Box>
                      <Box>
                        <Typography
                          className="body-xxs"
                          sx={{ fontWeight: 600 }}
                        >
                          Final NOC
                        </Typography>
                        <Typography className="body-xxs gray-900">
                          {final_license_date
                            ? (() => {
                                const expiryDate = new Date(final_expiry_date);
                                return `Expire on ${expiryDate.toLocaleDateString(
                                  "en-US",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  },
                                )}`;
                              })()
                            : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Button
                        variant="contained"
                        sx={{
                          background: "#3A1C73",
                          borderRadius: "999px",
                          textTransform: "none",
                          fontWeight: 500,
                          fontSize: 12,
                          boxShadow: "none",
                          "&:hover": { background: "#2a145c" },
                        }}
                        startIcon={<FileDownloadOutlinedIcon />}
                        onClick={() => {
                          // Replace with your actual download logic
                          if (final_licence_url) {
                            handleViewFile(final_licence_url);
                          }
                        }}
                      >
                        Download
                      </Button>
                      <IconButton
                        sx={{
                          ml: 2,
                          bgcolor: "#3A1C73",
                          "&:hover": {
                            bgcolor: "#2E155D",
                          },
                        }}
                        onClick={() => {
                          setOpenFinalQR(true);
                        }}
                      >
                        <QrCodeScanner sx={{ color: "#fff" }} />
                      </IconButton>

                      <QRLicenseGeneratorModal
                        open={openFinalQR}
                        onClose={() => setOpenFinalQR(false)}
                        licenseURL={final_licence_url}
                        licenseType="final"
                        moduleType="row"
                      />
                    </Box>
                  </Box>
                </Box>
              )
            )}
          </Box>

          {/* {showRejectionRemarks &&
            (status_id === 5 || status_id === 27 || status_id == 73) && (
              <Box
                sx={{
                  backgroundColor: "#FFF5F5", // Light pinkish background
                  border: "1px solid #FAD7D7",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "16px",
                  mt: 1,
                }}
              >
                <Typography
                  sx={{
                    color: "#B3261D",
                    fontWeight: 600,
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  Application Rejected Remarks
                </Typography>
                <Typography
                  sx={{ fontSize: "13px", color: "#333", marginBottom: "12px" }}
                >
                  "{rejectRemaks || "No remarks provided."}"
                </Typography>
                <Typography sx={{ fontSize: "13px", color: "#333" }}>
                  <strong style={{ color: "#B3261D" }}>Note:</strong> You can
                  request a review of the application until {expiryDateLabel} (
                  {daysLeft} {daysLeft === 1 ? "day" : "days"} from now).{" "}
                  <button
                    onClick={handleOpenReviewDrawer}
                    style={{
                      color: "#3A1C73",
                      backgroundColor: "transparent",
                      border: "none",
                      fontWeight: 600,
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Click here
                  </button>{" "}
                  to appeal.
                </Typography>
                {rejectRemaksDocument?.length > 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      mt: 1.5,
                    }}
                  >
                    {rejectRemaksDocument?.map((document: any) => (
                      <Box
                        key={document.id || document.upload_path}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          border: "1px solid #E0E0E0",
                          borderRadius: "8px",
                          padding: "8px 12px",
                          backgroundColor: "#FAFAFA",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            minWidth: 0,
                          }}
                        >
                          <DescriptionOutlinedIcon
                            sx={{
                              color: "#3A1C73",
                              fontSize: 20,
                            }}
                          />

                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              color: "#212121",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {document.file_name || document.document_name}
                          </Typography>
                        </Box>

                        <Button
                          variant="text"
                          onClick={() => handleViewRemarkDocument(document)}
                          sx={{
                            minWidth: "auto",
                            padding: "4px 8px",
                            color: "#3A1C73",
                            fontSize: "12px",
                            fontWeight: 500,
                            textTransform: "none",
                          }}
                        >
                          View
                        </Button>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )} */}

          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={8}>
              <Box className="app-section-header" mt={1}>
                <Box className="app-section-title">
                  <Typography className="section-heading">
                    Right of Way Permission Application Details
                  </Typography>
                </Box>
                <Box className="app-expand-buttons">
                  {allCollapsed ? (
                    <Button
                      startIcon={
                        <UnfoldMoreIcon className="rotate-45 brand-900" />
                      }
                      onClick={() => toggleApplicationPreviewSections(true)}
                    >
                      <Typography
                        className="brand-900"
                        sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                      >
                        Expand All
                      </Typography>
                    </Button>
                  ) : (
                    <Button
                      startIcon={
                        <UnfoldLessIcon className="rotate-45 brand-900" />
                      }
                      onClick={() => toggleApplicationPreviewSections(false)}
                    >
                      <Typography
                        className="brand-900"
                        sx={{ whiteSpace: "nowrap", fontWeight: 700 }}
                      >
                        {" "}
                        Collapse All
                      </Typography>
                    </Button>
                  )}
                </Box>
              </Box>
              <Box className="app-main-content flex flex-col gap-6">
                <IndividualDetailsROW
                  isExpanded={isApplicationDetailsExpanded.individualDetails}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      individualDetails: !prev.individualDetails,
                    }))
                  }
                  data={applicationDetailsROW}
                  visible={false}
                />
                <ApplicantOrganisationDetailsROW
                  isExpanded={isApplicationDetailsExpanded.organisationDetails}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      organisationDetails: !prev.organisationDetails,
                    }))
                  }
                  data={applicationDetailsROW}
                  visible={false}
                />
                <AmenityLocationSectionROW
                  isExpanded={isApplicationDetailsExpanded.ammentiesDetails}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      ammentiesDetails: !prev.ammentiesDetails,
                    }))
                  }
                  data={applicationDetailsROW}
                  visible={false}
                />
                <SiteRoadwaysSection
                  isExpanded={isApplicationDetailsExpanded.siteRoadways}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      siteRoadways: !prev.siteRoadways,
                    }))
                  }
                  data={applicationDetailsROW}
                  visible={false}
                />
                <RenewalDetailsSection
                  isExpanded={isApplicationDetailsExpanded.renewalDetails}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      renewalDetails: !prev.renewalDetails,
                    }))
                  }
                  applicationId={applicationId}
                  access={false}
                  category={applicationDetailsROW?.utility_type || ""}
                />
                <UploadedDocuments
                  isExpanded={isApplicationDetailsExpanded.documents}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      documents: !prev.documents,
                    }))
                  }
                  visible={false}
                />
                <MediaUpload
                  isExpanded={isApplicationDetailsExpanded.uploadMedia}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      uploadMedia: !prev.uploadMedia,
                    }))
                  }
                  visible={false}
                />
                <Consent
                  isExpanded={isApplicationDetailsExpanded.consent}
                  toggleExpand={() =>
                    setIsApplicationDetailsExpanded((prev) => ({
                      ...prev,
                      consent: !prev.consent,
                    }))
                  }
                  setConsentCheck={setConsentCheck}
                  consentCheck={consentCheck}
                  data={applicationDetailsROW}
                />
                <Box>
                  <BankGuaranteeDetails
                    data={bankGuaranteeDetails}
                    isExpanded={
                      isApplicationDetailsExpanded.bankGuarateeDetails
                    }
                    toggleExpand={() =>
                      setIsApplicationDetailsExpanded((prev) => ({
                        ...prev,
                        bankGuarateeDetails: !prev.bankGuarateeDetails,
                      }))
                    }
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              {/* 5 - provisional reject , 27- final reject , 48 - payment reject */}
              {(status_id === 5 || status_id === 27 || status_id === 48) && (
                <RejectRemaks status_id={status_id} remarks={rejectRemaks} />
              )}
              <WithdrawRemarks remarks={withdrawalRemarks} />
              <ApplicationStatus
                activityLogs={applicationDetailsROW?.activity_logs ?? []}
                receiptDetails={receiptDetails}
                detailsData={applicationDetailsROW}
              />
            </Grid>
          </Grid>
        </Box>
      </div>

      {/* Payment Popup */}

      <ProvisionalLicense
        applicationDetails={applicationDetailsROW}
        isPaymentOpen={isPaymentOpen}
        setIsPaymentOpen={setIsPaymentOpen}
        applicationId={applicationId}
        applicantName={applicantName}
        amenityName={amenityName}
        area={area}
        locationAddress={locationAddress}
      />
      <FinalLicenseModal
        applicationDetails={applicationDetailsROW}
        isFinalPaymentOpen={isFinalPaymentOpen}
        setIsFinalPaymentOpen={setIsFinalPaymentOpen}
        applicationId={applicationId}
        applicantName={applicantName}
        amenityName={amenityName}
        area={area}
        locationAddress={locationAddress}
      />

      {/* Payment Processing Dialog */}
      <Dialog
        open={isProcessing}
        onClose={() => setIsProcessing(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className="dialog-title">
          Payment Gateway
          <IconButton
            aria-label="close"
            onClick={() => setIsProcessing(false)}
            className="close-icon"
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          className="dialog-content"
          sx={{ textAlign: "center" }}
        >
          <Box className="dot-loader" />
          <Typography variant="subtitle2" className="popup-body">
            Payment Processing
          </Typography>
          <Typography variant="body2" className="dialog-description">
            You will be redirected to the Bharat Kosh portal to finalize your
            payment. Please do not close the page or press the back button till
            the transaction is complete.
          </Typography>
        </DialogContent>
      </Dialog>
      <RequestExtension
        isRequestExtensionOpen={isRequestExtensionOpen}
        setIsRequestExtensionOpen={setIsRequestExtensionOpen}
        applicationId={applicationId}
        provisionalExpiryDate={provisional_expiry_date}
        onSuccess={() => dispatch(fetchApplicationROWDetails(applicationId))}
      />
      {/* Request Extension Dialog */}
      {/* <RequestFinalLicence
        isRequestFinalLicenceOpen={isUploadMediaOpen}
        setIsRequestFinalLicenceOpen={setIsUploadMediaOpen}
        applicationId={applicationId}
      /> */}

      <RequestFinalLicence
        isRequestFinalLicenceOpen={isUploadMediaOpen}
        setIsRequestFinalLicenceOpen={(value: boolean) => {
          setIsUploadMediaOpen(value);

          if (!value && applicationId) {
            dispatch(fetchApplicationROWDetails(applicationId));
          }
        }}
        applicationId={applicationId}
        provisional_license_date={provisional_license_date}
        onSuccess={() => {
          dispatch(fetchApplicationROWDetails(applicationId));
        }}
      />

      {/* end */}
      <ConfirmationFinalModal
        isConfirmationFLOpen={isConfirmationFLOpen}
        setIsConfirmationFLOpen={setIsConfirmationFLOpen}
        setIsUploadMediaOpen={setIsUploadMediaOpen}
        setIsNoConfirmationFLOpen={setIsNoConfirmationFLOpen}
      />
      <NoConfirmationFinal
        isNoConfirmationFLOpen={isNoConfirmationFLOpen}
        setIsNoConfirmationFLOpen={setIsNoConfirmationFLOpen}
      />
      <WithdrawApplicationModel
        open={openWithdrawDrawer}
        onClose={() => setOpenWithdrawDrawer(false)}
        access_id={applicationId}
        onSuccess={() => {
          dispatch(fetchApplicationROWDetails(applicationId));
        }}
      />

      <RequestReviewDrawer
        open={isReviewDrawerOpen}
        onClose={handleCloseReviewDrawer}
        applicationId={applicationId}
        onSuccess={() => {
          dispatch(fetchApplicationROWDetails(applicationId));
        }}
      />
    </Box>
  );
};
